import axios from 'axios';
import CustomStorage from '@glenngijsberts/customstorage';
import keys from '../keys';
import { getHeaders, getToken } from '../helpers/auth';

class Ghost {
    login({ type = null, id = null }) {
        return new Promise((resolve, reject) => {
            const url = `${keys.API_URL}/api/auth/ghost/login`;

            const tokens = {};

            if (!id) reject();
            if (!type) reject();

            axios({
                method: 'POST',
                url,
                data: {
                    type,
                    id,
                },
                headers: getHeaders(getToken()),
            })
                .then((response) => {
                    const now = new Date().getTime() / 1000;

                    tokens.access_token = response.data.access_token;
                    tokens.expires_in = response.data.expires_in;
                    tokens.token_type = response.data.token_type;
                    tokens.refresh_at = now + response.data.expires_in - 1200;
                    tokens.parent = response.data.parent;

                    axios({
                        method: 'GET',
                        url: `${keys.API_URL}/api/auth/me`,
                        headers: getHeaders(tokens.access_token),
                    })
                        .then((res) => {
                            tokens.user = res.data.data;
                            tokens.parent = CustomStorage.get('auth');
                            CustomStorage.set('auth', tokens, response.data.expires_in / 60);

                            resolve();
                        })
                        .catch((error) => reject(error));
                })
                .catch((error) => reject(error));
        });
    }

    logout(depth) {
        return new Promise((resolve, reject) => {
            let tokens = CustomStorage.get('auth');

            let i = 0;

            while (i < depth) {
                if (!Object.prototype.hasOwnProperty.call(tokens, 'parent')) {
                    reject();
                }

                tokens = tokens.parent;

                i += 1;
            }

            CustomStorage.set('auth', tokens, tokens.expires_in / 60);

            resolve();
        });
    }
}

export default new Ghost();
